// extracted by mini-css-extract-plugin
module.exports = {"content":"workingoperation_content__360rA","center":"workingoperation_center__3snfD"};